import React,{useState, useEffect} from 'react';
import axios from 'axios';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';

import { Button } from '@mui/material';

const ChangeDate = () => {
    const location = useLocation();
    const id = location.search.split('=');
        let access = localStorage.getItem("accesstoken");
        const searchid = Number(id[1]);
        useEffect(() => {
         axios.get(`${databaseUrl}/orderboard/find?id=${searchid}`,{
            headers: {Authorization:`Bearer ${access}`},
        }).then((response)=>{
            if(response.data === 'NotAdmin'){
              alert('No access ')
              setNotaccess('You are Not access');
            }else{
                setNumber(response.data.id)
                setInputDate(response.data.inputdate)
                setCompany(response.data.order_company)
                setMaterial(response.data.material)
                setWeight(response.data.material_weight)
                setDue_date(response.data.due_date)
                setIsdeposit(response.data.deposit)
                setdepositPrice(response.data.deposit_price)
                setDepositDay(response.data.deposit_day)
                setDepositSend(response.data.deposit_send)
                setDelivery(response.data.delivery)
                setDeliverydate(response.data.delivery_date)
                setNote(response.data.note)
            }
        }).catch((error)=>{
            const refresh = localStorage.getItem("refreshtoken");
            axios.post(`${databaseUrl}/users/refresh`,{
              headers: {Authorization:`Bearer ${refresh}`},
            },{
    
            }).then( (response)=>{
              localStorage.setItem("accesstoken",response.data.accesstoken);
              localStorage.getItem("refreshtoken",response.data.refreshtoken);
    
              window.location.reload();
        
            }).catch((error) => {alert(error);})
        })
    }, [])
    const [notaccess, setNotaccess] = useState('');
    const [number,setNumber] = useState('');
    const [inputdate,setInputDate] = useState('');
    const [company,setCompany] = useState('');
    const [material,setMaterial] = useState('');
    const [weight,setWeight] = useState('');
    const [due_date,setDue_date] = useState('');
    const [isdeposit,setIsdeposit] = useState('');
    const [depositPrice,setdepositPrice] = useState('');
    const [depositDay,setDepositDay] = useState('');
    const [depositSend,setDepositSend] = useState('');
    const [delivery,setDelivery] = useState('');
    const [note,setNote] = useState('');
    const [deliverydate,setDeliverydate] = useState('');

    const sendChangedDate = () => {
        const changDate = due_date;
        axios.get(`${databaseUrl}/orderboard/changedate?id=${number}&chdate=${deliverydate}`,{
            headers: {Authorization:`Bearer ${access}`},
        }).then((response)=>{
            window.open('','_self').close(); 
        })
    }
    return (
        <div>
        <div><h1>{notaccess}</h1></div>
        <table className='table_normal'>
            <thead>
            <tr>
                <th>번호</th>
                <th>접수일</th>
                <th>발주처</th>
                <th>품명</th>
                <th>수량</th>
                <th>요청납기일</th>
                <th>선입금</th>
                <th>선입금액</th>
                <th>입금일</th>
                <th>입금금액</th>
                <th>배송</th>
                <th>배송일</th>
                <th>비고</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>{number}</td>
                <td>{inputdate.substring(0,10)}</td>
                <td>{company}</td>
                <td>{material}</td>
                <td>{weight}</td>
                <td>{due_date}</td>
                <td>{isdeposit}</td>
                <td>{depositPrice}</td>
                <td>{depositDay}</td>
                <td>{depositSend}</td>
                <td>{delivery}</td>
                <td className='mustinput'><input type='date' value={deliverydate} onChange={(event)=>setDeliverydate(event.target.value)}></input></td>
                <td>{note}</td>
            </tr>
            <tr><td colSpan='13'>
                <Button onClick={sendChangedDate} size='large' variant="contained" color="success"  sx={{width:'100%'}}>Submit</Button>
            </td>
            </tr>
            </tbody>
        </table>
        </div>
    )
}
export default ChangeDate;
